import { render, staticRenderFns } from "./MyProjectsInvoice.vue?vue&type=template&id=32e06043&scoped=true"
import script from "./MyProjectsInvoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsInvoice.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsInvoice.vue?vue&type=style&index=0&id=32e06043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e06043",
  null
  
)

export default component.exports